import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf';
import { withTranslation } from 'react-i18next';
import { Button, Pagination, Loading } from 'virtues-bootstrap';
import { uploadFile } from 'utilities/uploadFile';

import s from './styles.module.scss';

const PdfViewer = ({ pdfFileObject, t }) => {
  const [totalPages, setTotalPages] = useState(null);
  const [page, setPageNumber] = useState(1);
  const [isShowing, setHideShowPdf] = useState(false);
  const [pdfContent, setPdfContent] = useState(null);

  useEffect(() => {
    const loadPdfContent = async () => {
      const [result] = await uploadFile([pdfFileObject]);
      setPdfContent(result.data);
    };

    loadPdfContent();
  }, [pdfFileObject]);

  return (
    <div className={s.pdfContentWrapper}>
      {isShowing && (
        <>
          <Document
            className={s.document}
            file={`data:application/pdf;base64,${pdfContent}`}
            renderMode="svg"
            loading={<Loading className={s.pdfLoader} variant="primary" />}
            onLoadSuccess={({ numPages }) => setTotalPages(numPages)}
          >
            <Page className={s.pageInnerPdf} pageNumber={page} />
          </Document>
          {totalPages && (
            <Pagination
              className={s.pagesWrapper}
              initialPage={page - 1}
              pageCount={totalPages}
              t={t}
              onPageChange={i => setPageNumber(i + 1)}
            />
          )}
        </>
      )}
      <div className={s.showHideButton}>
        <Button onClick={() => setHideShowPdf(!isShowing)}>
          {t('reports.showHidePdfContent')}
        </Button>
      </div>
    </div>
  );
};

PdfViewer.propTypes = {
  t: PropTypes.func.isRequired,
  pdfFileObject: PropTypes.shape({}).isRequired,
};

export default withTranslation()(PdfViewer);
